 
import BaseApi from "../Core/BaseApi";
 
import { Document } from "../Entity/Document";
import Product from "../Entity/Product"

export default class NewArrivalDataService extends BaseApi {
    public static GetAll() {
        return this.BasePostRequestAsync<Product[]>("ProductWebsite/GetAll", null);
    }
}

export class NewArrivalGetAllRequestEntity{

}